import type {Component} from '@kpsys/angularjs-register';
import type {ServerFolder} from 'typings/portaro.be.types';

export class KpReportServerFolderComponentController implements KpReportServerFolderComponentBindings {
    public serverFolder: ServerFolder;
}

/**
 * @ngdoc component
 * @name kpReportServerFolderComponent
 * @module use-cases.report-server
 *
 * @param {ServerFolder=} serverFolder
 *
 * @description
 *
 * Component which holds folder structure and ReportTemplates (kpReportTemplateItemComponent)
 *
 */
export default class KpReportServerFolderComponent implements Component<KpReportServerFolderComponentBindings> {
    public static readonly componentName = 'kpReportServerFolder';

    public templateUrl = require('./kp-report-server-folder.tpl.ftl');

    public bindings = {
        serverFolder: '<',
    } as const;

    public controller = KpReportServerFolderComponentController;
}

interface KpReportServerFolderComponentBindings {
    serverFolder: ServerFolder;
}
